/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue'

require('../bootstrap');

import PayoneClient from './components/checkout/PayoneClient';
import RateCalculator from './components/checkout/RateCalculator';
import Checkout from './components/checkout/Checkout';
import DateEditor from './components/DateEditor';
import Test from './components/content/learning_unit/Test';
import Question from './components/content/learning_unit/test/Question';
import Choices from './components/content/learning_unit/test/Choices';
import TestPager from './components/content/learning_unit/test/partials/TestPager';
import TestStart from './components/content/learning_unit/TestStart';
import TestOverview from './components/content/learning_unit/TestOverview';
import TestTimer from './components/content/learning_unit/test/partials/TestTimer';
import PartnerList from './components/content/learning_unit/PartnerList';
import PresenceAppointment from './components/content/learning_unit/PresenceAppointment';
import TalkAppointment from './components/content/learning_unit/TalkAppointment';
import Partner from './components/content/learning_unit/partner/Partner';
import Totals from './components/checkout/totals/Totals';
import DatePicker from './components/checkout/course/DatePicker';
import PaperTheme from './components/content/learning_unit/PaperTheme';
import GiveUsFeedback from './components/Feedback/GiveUsFeedback';

Vue.component('payone-client', PayoneClient);
Vue.component('rate-calculator', RateCalculator);
Vue.component('checkout', Checkout);
Vue.component('date-editor', DateEditor);
Vue.component('test', Test);
Vue.component('test-pager', TestPager);
Vue.component('test-overview', TestOverview);
Vue.component('test-start', TestStart);
Vue.component('test-timer', TestTimer);
Vue.component('question', Question);
Vue.component('choices', Choices);
Vue.component('partner-list', PartnerList);
Vue.component('presence-appointment', PresenceAppointment);
Vue.component('talk-appointment', TalkAppointment);
Vue.component('partner', Partner);
Vue.component('totals', Totals);
Vue.component('course-date-picker', DatePicker);
Vue.component('paper-theme', PaperTheme)
Vue.component('feedback', GiveUsFeedback)

require('../vue');
